// extracted by mini-css-extract-plugin
export default {"course":"Course_course__Tdzsi"};